import { Component, OnInit } from '@angular/core';

import { tanquesEstoqueModuleName, tanquesModuleName } from "../shared/data.service";
import { Tanque } from "../shared/tanque.model";
import { TanqueApiService } from "../shared/tanque-api.service";
import { TanqueService } from "../shared/tanque.service";
import { TanqueNavigationService } from "../shared/tanque-navigation.service";
import {abastecimentosModuleName} from "../../shared/data.service";

@Component({
    template: require('./tanque-estoque-list.component.html'),
    styles: [require('./tanque-estoque-list.component.css')]
})
export class TanqueEstoqueListComponent implements OnInit {
    list: Tanque[] = [];
    loading: boolean = true;
    tanquesEstoqueModuleName: any = tanquesEstoqueModuleName;
    tanquesModuleName: any = tanquesModuleName;
    tabSelected: string = 'tanques';
    module: any = abastecimentosModuleName;

    constructor(
        private _tanquesApiService: TanqueApiService,
        private _tanqueService: TanqueService,
        private _tanqueNavigationService: TanqueNavigationService,
    ) { }

    ngOnInit() {
        this.getByTanque();
    }

    clickNew() {
        this._tanqueNavigationService.goToMovimentacaoNew();
    }

    clickDetail(item: any) {
        this._tanqueNavigationService.goToMovimentacaoDetail(item.id);
    }

    setTab(tab:string) {
        this.tabSelected = tab;
        this.list = [];
        this.loading = true;

        if (tab === 'tanques') {
            this.getByTanque();
        } else if (tab === 'areas') {
            this.getByArea();
        } else if (tab === 'orgaos') {
            this.getByOrgao();
        }
    }

    isTab(tab: string) {
        let isTab: boolean = (tab === this.tabSelected) ? true: false;
        return isTab;
    }

    private getByTanque() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.checkTanque(Response);
            }
            this.loading = false;
        }.bind(this));

        this._tanquesApiService.onGetEstoqueByTanque(onDone);
    }

    private getByArea() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._tanquesApiService.onGetEstoqueByArea(onDone);
    }

    private getByOrgao() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._tanquesApiService.onGetEstoqueByOrgao(onDone);
    }

    private checkTanque(itens: any[]) {
        let x: number, lenX: number,
            list: any[] = [],
            yellowState: number,
            redState: number;

        for (x = 0, lenX = itens.length; x < lenX; x++) {
            if (itens[x].ativo) {
                if (itens[x].statusAmarelo) {
                    yellowState = (itens[x].statusAmarelo / 100) * itens[x].capacidade;
                } else {
                    yellowState = 0;
                }

                if (itens[x].statusVermelho) {
                    redState = (itens[x].statusVermelho / 100) * itens[x].capacidade;
                } else {
                    redState = 0;
                }

                if (itens[x].total <= redState) {
                    itens[x].statusColor = 'red';
                } else if (itens[x].total <= yellowState) {
                    itens[x].statusColor = 'yellow';
                } else {
                    itens[x].statusColor = 'green';
                }

                list.push(itens[x]);
            }
        }
        this.list = list;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/tanque-estoque-list/tanque-estoque-list.component.ts
 **/